const AmeegoExplanationText = () => {
  return (
    <p>
      Ameegos may charge a small fee for their knowledge and time. Their average
      rate will be communicated on their profile and a rate for the level of
      help you require will be agreed between both parties beforehand.
    </p>
  );
};

export default AmeegoExplanationText;
